import axios, { AxiosHeaders } from "axios";
import { deleteCookie, getCookie } from "../utils/helper";
import Konsole from "../utils/konsole/Konsole";
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_DEV,
  // process.env.NODE_ENV === "development"
  //   ? process.env.REACT_APP_BASE_URL_DEV
  //   : process.env.REACT_APP_BASE_URL_LIVE,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});
axiosInstance.interceptors.request.use(
  async (config) => {
    // const token = localStorage.getItem("yop-token") || "";
    const token = getCookie("yop-token") || "";
    const language = sessionStorage.getItem("i18nextLng") || "";
    if (config.headers) {
      (config.headers as AxiosHeaders).set("Authorization", `Bearer ${token}`);
      (config.headers as AxiosHeaders).set("language", `${language}`);
      (config.headers as AxiosHeaders).set("device-type", `web_enable`);
      (config.headers as AxiosHeaders).set(
        "url",
        `${process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DOMAIN_URL
          : window.location.origin
        }`
      );
      (config.headers as AxiosHeaders).set(
        "store-id",
        sessionStorage.getItem("store-id") || ""
      );
    }

    return config;
  },
  (error) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("_error", error)
    if (
      error?.response?.status === 401
      &&
      !error.request?.responseURL?.includes("/get/user/address")
    ) {

      localStorage.clear();
      sessionStorage.clear();
      deleteCookie('yop-token');
      deleteCookie('user-data');
      window.location.reload();
      sessionStorage.clear();
      deleteCookie('yop-token');
      deleteCookie('user-data');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
